import React from "react";
import { CityAdSlot } from "@/components/CityAdSlot";

/** Thin wrapper over the platform's existing rail ad unit — new to the storefront in this PR
 * (`BusinessMiniSite` never carried one). Gated on `storefront_config.ads.allow`: an owner can
 * opt out, `!== false` so an unset config (every business before this PR) defaults to allowed.
 * `showPlaceholder` is deliberately omitted — a business's own page showing "buy an ad here"
 * every time a slot is unsold would be a new, unrequested nag; it renders nothing when vacant. */
export function RailAd({ business, ad, rate }) {
  if (business.storefront_config?.ads?.allow === false) return null;
  // UAT A1: a shop never advertises itself on its own page (nor does the city rail show a
  // business its own ad) — render nothing rather than a self-promotion.
  if (ad?.advertiser_business_id && ad.advertiser_business_id === business.id) return null;
  return <CityAdSlot ad={ad} slot="rail" testId="storefront-ad-rail" rate={rate} />;
}
